import { message, Typography } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import api from 'api'
import { SimpleCustomerForm } from 'components/models/customers'
import { LimitedEventInformation } from 'components/pages/event/details/EventInformation'
import { Button } from 'components/shared/Button'
import { useAuth } from 'contexts/auth'
import { urls } from 'helpers/urls'
import { useCustomerRegistered } from 'hooks/customers'
import { EventType } from 'hooks/events'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import LockIcon from 'public/icons/lock.svg'
import { FC, useEffect, useState } from 'react'

type Props = {
  event: EventType
  mutateEvent: () => void
}

export const LimitedEventPage: FC<Props> = ({ event, mutateEvent }) => {
  const { xs } = useBreakpoint()
  const { t } = useTranslation()
  const router = useRouter()
  const { user, setIsSignUpOpened } = useAuth()
  const [visible, setVisible] = useState(false)

  const token = router.query.token
  const [isLoadingUpdateRank, setIsLoadingUpdateRank] = useState(false)
  const {
    data: customerRegistered,
    isValidating: isValidatingCustomer,
    mutate: mutateCustomerRegistered,
  } = useCustomerRegistered({ ownerId: event.owner.id, isReady: !!user })

  useEffect(() => {
    const checkToken = async () => {
      if (!token || isValidatingCustomer) return

      if (!user) {
        message.success(t('イベントを確認するには会員登録が必要です。'))
        setIsSignUpOpened(true)
        return
      }

      if (!customerRegistered) {
        setVisible(true)
        message.success(t('イベントを確認するには登録が必要です。'))
        return
      }

      if (isLoadingUpdateRank) return

      setIsLoadingUpdateRank(true)
      const { data, error }: { data: any; error: any } = await api.patch(
        `/events/${event.id}/up_customer_rank`,
        { token: token },
      )
      if (data) {
        message.success(t('ランクが更新されました'))
        mutateEvent()
      }
      if (error) {
        message.error(error.data.error)
      }
    }
    checkToken()
  }, [
    customerRegistered,
    event.id,
    token,
    isLoadingUpdateRank,
    isValidatingCustomer,
    mutateEvent,
    setIsSignUpOpened,
    t,
    user,
    router,
  ])

  return (
    <>
      <div style={{ padding: xs ? '0px 0px 160px' : '40px 64px 250px' }}>
        <LimitedEventInformation event={event} />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: 80,
          }}
        >
          <Typography.Text
            style={{
              fontSize: 16,
              lineHeight: 1,
              color: 'black',
              display: 'flex',
              alignItems: 'center',
              fontWeight: 700,
            }}
          >
            <LockIcon style={{ width: 24, height: 24, fill: 'black' }} />
            {t('このイベントは限定公開です')}
          </Typography.Text>
          <Button
            type="secondary"
            href={urls.top}
            style={{
              marginTop: 24,
              padding: '16px',
              width: 262,
              display: 'flex',
              alignItems: 'center',
              fontSize: 16,
              lineHeight: 1,
              fontWeight: 700,
            }}
          >
            {t('TOPへ戻る')}
          </Button>
        </div>
      </div>
      {visible && (
        <SimpleCustomerForm
          visible={visible}
          setVisible={setVisible}
          mutateCustomer={mutateCustomerRegistered}
          ownerId={event.owner.id}
          user={user}
        />
      )}
    </>
  )
}
